import { StyleSheet } from "aphrodite/no-important";
import { colour, font } from "../style/base-theme";

export const styles = StyleSheet.create({
  inlineLink: {
    color: colour.brand.red
  },

  buttonWhite: {
    //display: 'block',
    background: "#fff",
    borderRadius: 500,
    fontWeight: 600,
    color: colour.brand.blue,
    padding: 13,
    fontSize: 18,
    border: 0,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    cursor: "pointer",
    ":hover": {
      background: "rgba(255,255,255,0.9)"
    },
    ":disabled": {
      opacity: 0.5,
      cursor: "not-allowed"
    }
  },
  background: {
    height: "100vh",
    padding: 20,
    backgroundImage: "linear-gradient(-180deg, #00CAFF 0%, #0096D8 100%)"
  },
  input: {
    border: "1px solid rgba(255,255,255,0.7)",
    padding: "13px 20px",
    borderRadius: "500px",
    background: "none",
    width: "100%",
    marginBottom: 20,
    fontSize: 18,
    color: "#fff",
    "::placeholder": {
      color: "#fff"
    },
    ":focus, :hover": {
      borderColor: "rgba(255,255,255,0.7)",
      outline: "none"
    }
  },
  error: {
    color: "#D80000",
    fontSize: 16,
    paddingBottom: 20,
    display: "block"
  },
  inputError: {
    borderColor: "#D80000",
    marginBottom: 5
  },
  wrapper: {
    maxWidth: 600,
    margin: "0 auto"
  },
  label: {
    fontSize: 16,
    color: "#fff",
    margin: 0,
    marginBottom: 5,
    display: "block",
    padding: 0,
    fontWeight: 600
  },
  paragraph: {
    color: "#fff",
    fontSize: 18,
    margin: "0 0 20px 0"
  },
  checkIcon: {
    marginRight: 20,
    height: 30,
    flex: "30px 0 0"
  },
  successTitle: {
    margin: 0,
    color: "#fff",
    fontSize: 18
  },
  successWrapper: {
    display: "flex",
    alignItems: "center"
  }
});
